import { render } from "./AvatarContainer.vue?vue&type=template&id=040d615e&scoped=true&ts=true"
import script from "./AvatarContainer.vue?vue&type=script&lang=ts"
export * from "./AvatarContainer.vue?vue&type=script&lang=ts"

import "./AvatarContainer.vue?vue&type=style&index=0&id=040d615e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040d615e"]])

export default __exports__